var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlFireplaceFilled = function SvgHtlFireplaceFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 3v10h10V3H3Zm0-1h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.926 13.954a.492.492 0 0 1-.172-.031 4.758 4.758 0 0 1-1.63-1.1 4.061 4.061 0 0 1-.985-3.936c.807-3.453 2.552-4.728 2.625-4.781a.5.5 0 0 1 .752.229l.66 1.7.1.259.2.516.115-.181.068-.106c.36-.562.722-1.122.722-1.122a.5.5 0 0 1 .378-.227h.043a.502.502 0 0 1 .367.161 9.309 9.309 0 0 1 1.818 3.66 3.756 3.756 0 0 1-.447 3.209 4.712 4.712 0 0 1-2.613 1.73.5.5 0 0 1-.62-.338c-.04-.135-.239-.183-.41-.183-.2 0-.447.067-.5.213a.499.499 0 0 1-.471.328ZM6.509 9a.5.5 0 0 0-.493.431 2.512 2.512 0 0 0 1.73 2.748.5.5 0 1 0 .311-.951 1.516 1.516 0 0 1-1.05-1.661.5.5 0 0 0-.5-.567h.002Z"
  })));
};
export default SvgHtlFireplaceFilled;